/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Contact_Reason_Built_TermInputs */

const en_marketing_contact_reason_built_term = /** @type {(inputs: Marketing_Contact_Reason_Built_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want it built for you?`)
};

const es_marketing_contact_reason_built_term = /** @type {(inputs: Marketing_Contact_Reason_Built_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres que lo construyamos?`)
};

const fr_marketing_contact_reason_built_term = /** @type {(inputs: Marketing_Contact_Reason_Built_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous voulez qu'on le construise ?`)
};

/**
* | output |
* | --- |
* | "Want it built for you?" |
*
* @param {Marketing_Contact_Reason_Built_TermInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_contact_reason_built_term = /** @type {((inputs?: Marketing_Contact_Reason_Built_TermInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Contact_Reason_Built_TermInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_contact_reason_built_term(inputs)
	if (locale === "es") return es_marketing_contact_reason_built_term(inputs)
	return fr_marketing_contact_reason_built_term(inputs)
});